import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, Immobilie, VwgVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export interface Nebengebaeude {
  vorhanden: boolean;
  gesamtflaeche: number;
}

export interface Gebaeude {
  baujahr: number;
  wohnflaeche: number;
  nebengebaeude: Nebengebaeude;
  plzFaktorErdb?: number;
  plzFaktorSnd?: number;
  plzFaktorGla?: number;
  plzFaktorHws?: number;
}

export const gebaeudeReducer = function (
  sectionState: Gebaeude = null,
  action: AnyAction,
  appState: IAppState,
): Gebaeude {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      if (action.payload.appId !== App.VWG || action.payload.angebotsId !== appState.angebotsId) {
        return sectionState;
      }

      const immobilie = action.payload.immobilie as Immobilie;
      return {
        baujahr: immobilie.baujahr,
        wohnflaeche:
          immobilie.wohnflaeche != null && immobilie.wohnflaeche > 0 ? immobilie.wohnflaeche : null,
        nebengebaeude: {
          vorhanden: immobilie.nebengebaeudeVorhanden ? immobilie.nebengebaeudeVorhanden : false,
          gesamtflaeche: immobilie.nebengebaeudeQM > 0 ? immobilie.nebengebaeudeQM : null,
        } as Nebengebaeude,
      } as Gebaeude;
    }
    case VwgActions.BAUJAHR_CHANGED: {
      return {
        ...sectionState,
        baujahr: action.payload.baujahr,
      };
    }
    case VwgActions.WOHNFLAECHE_CHANGED: {
      return {
        ...sectionState,
        wohnflaeche: action.payload.wohnflaeche,
      };
    }
    case VwgActions.NEBENGEBAEUDE_CHANGED: {
      return {
        ...sectionState,
        nebengebaeude: {
          ...sectionState.nebengebaeude,
          vorhanden: action.payload.vorhanden,
          gesamtflaeche: action.payload.vorhanden ? sectionState.nebengebaeude.gesamtflaeche : null,
        },
      };
    }
    case VwgActions.GESAMTFLAECHE_CHANGED: {
      return {
        ...sectionState,
        nebengebaeude: {
          ...sectionState.nebengebaeude,
          gesamtflaeche: action.payload.gesamtflaeche,
        },
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VWG && actionPayload.angebotsId === appState.angebotsId) {
        return {
          ...sectionState,
          wohnflaeche: actionPayload.wohnflaeche,
          baujahr: actionPayload.baujahr,
          nebengebaeude: {
            vorhanden: actionPayload.merkmale?.nebengebaeudeQM !== null,
            gesamtflaeche: actionPayload.merkmale?.nebengebaeudeQM,
          },
          plzFaktorErdb: actionPayload.plzFaktorErdb,
          plzFaktorSnd: actionPayload.plzFaktorSnd,
          plzFaktorGla: actionPayload.plzFaktorGla,
          plzFaktorHws: actionPayload.plzFaktorHws,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
